import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-info-box',
  imports: [CommonModule],
  templateUrl: './info-box.component.html',
  styleUrl: './info-box.component.css',
})
export class InfoBoxComponent {
  @Input() label!: string;
  @Input() value!: string;
  @Input() isStatus: boolean = false;
}
